import { EventBusListenersMap, IEventBus } from '../types';

export class EventBusStub implements IEventBus<EventBusListenersMap> {
    public addListener<K extends keyof EventBusListenersMap>(type: K, listener: EventBusListenersMap[K]) {}
    public removeListener<K extends keyof EventBusListenersMap>(type: K, listener: EventBusListenersMap[K]) {}
}
